const host = 'http://cdn.shikehuyu.com/yfjs'

// 精灵图
const sprites = []
const resourceKeys = [
  [
    'sky', 'grass1', 'grass2', 'ground', 'pole', 'static1', 'static2', 'static3',
    'water1', 'water2', 'cloud2', 'cloud3', 'talk1', 'talk2', 'text',
    'bike', 'hand', 'wheel1', 'wheel2', 'shadow', 'shadow2', 'mother'
  ],
  [
    'static', 'hand', 'child1', 'child2', 'plane', 'cloud1', 'cloud2',
    'people', 'door', 'talk1', 'talk2', 'text'
  ],
  [
    'bg', 'clock', 'hour', 'minute', 'calender', 'child', 'light',
    'bookcase', 'door', 'talk1', 'talk2', 'textnew'
  ],
  [
    'staticnew', 'text', 'talk'
  ],
  [
    'bg', 'father', 'me1', 'me2', 'textnew', 'talk1', 'talk2', 'money'
  ],
  [
    'static', 'me1', 'me2', 'talk1', 'text'
  ],
  [
    'static', 'fingerexit', 'fingernormal', 'fingerwork', 'fingergame', 'fingermother',
    'fingermother2', 'head', 'wechat1new', 'wechat2', 'wechat3', 'wechat4',
    'static2', 'text1', 'text2', 'text3', 'text4'
  ],
  [
    'static',
    'bg', 'star', 'talk', 'text', 'text2', 'static2',
    'btnagain', 'btnshare', 'js', 'logo', 'text3'
  ]
]
// 场景一帧动画
for (let i = 1; i <= 6; i += 1) resourceKeys[0].push(`leg${i}`) // 单车-腿
for (let i = 1; i <= 11; i += 1) resourceKeys[0].push(`walk${i}`) // 行人
// 场景三帧动画
for (let i = 1; i <= 8; i += 1) resourceKeys[2].push(`mother${i}`) // 母亲
// 场景四帧动画
for (let i = 1; i <= 9; i += 1) resourceKeys[3].push(`page${i}`) // 翻页
// 场景五帧动画
for (let i = 1; i <= 2; i += 1) resourceKeys[4].push(`mother${i}`) // 母亲
// 场景六帧动画
for (let i = 1; i <= 13; i += 1) resourceKeys[5].push(`red${i}`) // 红点
// 场景八帧动画
for (let i = 1; i <= 10; i += 1) resourceKeys[7].push(`bird${i}`) // 鸟
for (let i = 1; i <= 4; i += 1) resourceKeys[7].push(`me${i}`) // 转身
for (let i = 1; i <= 5; i += 1) resourceKeys[7].push(`walk${i}`) // 走路

resourceKeys.forEach((scene, index) => {
  scene.forEach((key) => {
    sprites.push({
      name: `s${index + 1}_${key}`,
      url: `${host}/scene${index + 1}/${key}.png`
    })
  })
})

// 音频
const audios = []

export default {
  sprites,
  audios
}



// WEBPACK FOOTER //
// ./src/assets/resource.js